import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { RoutePaths } from '../../constants';
import { BlockWrapperWithSpinner } from 'components';
import { selectCurrentUser } from 'store/auth/selectors';
import { useSelector } from 'store/utils';
import { UserRole } from 'types';

type Props = {
  roles: UserRole[];
  children: ReactNode;
  redirectTo?: RoutePaths;
};

export const ProtectedRoute = ({ roles, children, redirectTo = RoutePaths.DASHBOARD }: Props) => {
  const currentUser = useSelector(selectCurrentUser);

  if (!currentUser?.role) return <BlockWrapperWithSpinner isLoading />;

  if (roles.includes(currentUser.role)) return <>{children}</>;

  return <Navigate to={redirectTo} replace={true} />;
};
